



















































































































import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { UsersData } from '@attensi/api-js';

import Sidebar from './Sidebar.vue';
import LanguageSelect from './LanguageSelect.vue';
import NavbarLink from './NavbarLink.vue';

Vue.directive('resize', {
  inserted(el, binding) {
    const f = (evt: any) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('resize', f);
      }
    };
    window.addEventListener('resize', f);
  },
});

@Component({
  components: { Sidebar, LanguageSelect, NavbarLink },
})
export default class Navbar extends Vue {
  private user: UsersData | null = null;

  @Getter('showSidebar') showSidebar!: boolean;
  @Getter('fullNavbar') fullNavbar!: boolean;


  locale: string = 'en';
  navbarDropdownOpen: boolean = false;

  get pathComponentName(): string | undefined {
    return this.$route.name;
  }
  get isAdmin(): boolean {
    if (!this.user || !this.user.roles) {
      return false;
    }
    return this.user.roles.includes('admin');
  }
  get isManager(): boolean {
    if (!this.user || !this.user.roles) {
      return false;
    }
    return this.user.roles.includes('manager');
  }

  // TODO fix toggle sidebar and fullnavbar
  @Action('setShowSidebar') setShowSidebar: any;
  @Action('setFullNavbar') setFullNavbar: any;

  toggleShowSidebar(): void {
    this.setShowSidebar(!this.showSidebar);
  }

  adjustNavbarContent(evt: any, el: any): void {
    if (el.clientWidth < 750) {
      if (this.fullNavbar) {
        this.setFullNavbar(false);
      }
    } else {
      if (!this.fullNavbar) {
        this.setFullNavbar(true);
      }
    }
  }
  mounted() {
    this.adjustNavbarContent(null, this.$refs.navbar);
  }

  async created() {
    try {

      const userResponse = await this.$portal.getUsersMe();
      this.user = userResponse.data;

    } catch (err) {
      throw err;
    }
  }

}
